// routes
import { paths } from 'src/routes/paths';
// utils
import { axiosCorrespondenciaInstance as axios, axiosTicketInstance, axiosTramitesInstance } from 'src/utils/axios';

// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    alert('Token expired');

    sessionStorage.removeItem('accessToken');

    window.location.href = paths.auth.login || paths.auth.jwt.login;
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken) => {
  // console.log('Intentando guardar token en sessionStorage:', accessToken);
  if (accessToken) {
    sessionStorage.setItem('accessToken', accessToken);
    // console.log('Token almacenado en sessionStorage:', sessionStorage.getItem('accessToken'));
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    axiosTicketInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    axiosTramitesInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    const { exp } = jwtDecode(accessToken);
    tokenExpired(exp);
  } else {
    console.log('Eliminando token de sessionStorage');
    sessionStorage.removeItem('accessToken');

    delete axios.defaults.headers.common.Authorization;
    delete axiosTicketInstance.defaults.headers.common.Authorization;
    delete axiosTramitesInstance.defaults.headers.common.Authorization;
  }
};
